/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final amount`)
};

const es_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monto final`)
};

const de_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endbetrag`)
};

const nl_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eindbedrag`)
};

const fr_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant final`)
};

const it_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importo finale`)
};

const pt_br2_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor final`)
};

const pt_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montante final`)
};

const ja_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終金額`)
};

const zh_sip_result_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最终金额`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_result_amount = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_result_amount(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_result_amount", locale)
	if (locale === "en") return en_sip_result_amount(inputs)
	if (locale === "es") return es_sip_result_amount(inputs)
	if (locale === "de") return de_sip_result_amount(inputs)
	if (locale === "nl") return nl_sip_result_amount(inputs)
	if (locale === "fr") return fr_sip_result_amount(inputs)
	if (locale === "it") return it_sip_result_amount(inputs)
	if (locale === "pt-BR") return pt_br2_sip_result_amount(inputs)
	if (locale === "pt") return pt_sip_result_amount(inputs)
	if (locale === "ja") return ja_sip_result_amount(inputs)
	return zh_sip_result_amount(inputs)
};